import React from "react";

import theme from "@/foundation/Theme";

import {
  CallbackSuccessWrapper,
  RotateCheck,
  Description,
  Title,
  ActionButton,
  SecondaryCTAWrapper,
} from "./style";
import { SecondaryCTA } from "@/components/Molecules/EnrollNowButton/style";

const CallbackSuccess = ({
  title = "Thank you for showing interest!",
  description = "You will get a callback within 24 hours.",
  showButton = true,
  secondaryCTA,
  onButtonClick = () => {},
}) => {
  return (
    <CallbackSuccessWrapper
      id="callback-success"
      aria-labelledby="callback-success"
    >
      <RotateCheck
        icon="icon-check-circle-1"
        fill={theme.colors.textGradient.type3static}
      />
      <Title variant="heading2">{title}</Title>
      <Description
        variant="paragraph1"
        color={theme.colors.gray_100}
        mb={showButton ? "25px" : "0px"}
      >
        {description}
      </Description>
      {showButton && (
        <ActionButton variant="primary" onClick={() => onButtonClick()}>
          Ok, thanks!
        </ActionButton>
      )}
      {secondaryCTA && (
        <SecondaryCTAWrapper>{secondaryCTA}</SecondaryCTAWrapper>
      )}
    </CallbackSuccessWrapper>
  );
};

export default CallbackSuccess;
